export const i18n = {
  defaultLocale: process.env.DEFAULT_LANGUAGE,
  locales: ['en', 'mk', 'sr', 'sq'],
  localeDetails: {
    en: { name: 'English' },
    mk: { name: 'Македонски' },
    sq: { name: 'Shqip' },
    sr: { name: 'Srpski' },
  },
} as const;

export type Locale = (typeof i18n)['locales'][number];
